export const setJWTToken = (token) => {
	setStorage('jwtToken', token)
}

export const getJWTToken = () => {
	return loadStorage('jwtToken');
}

export const clearJWTToken = () => {
	localStorage.clear();
}

export const setGeneralStorage = (key, value) => {
	setStorage(key, value);
}

export const getGeneralStorage = (key) => {
	return loadStorage(key);
}

function setStorage(key, value){
	localStorage.setItem(key, value);
}

function loadStorage(key){
	return localStorage.getItem(key);
}